<template>
  <div id="soasta_pageinfo" style="display: none">
    <site>{{ soasta.site }}</site>
    <type>{{ soasta.soastaType }}</type>
    <release>{{ soasta.release }}</release>
    <version>{{ soasta.version }}</version>
    <nodeversion>{{ soasta.version }}</nodeversion>
    <noderelease>{{ soasta.release }}</noderelease>
    <releasedate>{{ soasta.releaseDate }}</releasedate>
    <xapirelease>{{ soasta.xapiRelease }}</xapirelease>
    <xapiversion>{{ soasta.xapiVersion }}</xapiversion>
    <timestamp>{{ soasta.timestamp }}</timestamp>
    <region>{{ soasta.region }}</region>
    <uiframework>nuxtjs</uiframework>
    <dependencies>
      <dependency v-for="dependency in soasta.dependencies" :key="dependency.artifactId">
        <artifactId>{{ dependency.artifactId }}</artifactId>
        <version>{{ dependency.version }}</version>
      </dependency>
    </dependencies>
  </div>
</template>

<script setup lang="ts">
const { pageData } = usePageData();
const soasta = pageData.soasta || {};
</script>
